import React from "react";
import { ArrowRightIcon } from "lucide-react";
interface HeroProps {
  onBook: () => void;
}
export function Hero({
  onBook
}: HeroProps) {
  return <section id="home" className="relative flex min-h-[640px] items-end overflow-hidden pt-16 lg:min-h-[92vh]" data-id="element-174" data-mp="ehtiju9l4xmr">
      <img src="https://cdn.magicpatterns.com/uploads/2je6jkvZSqNfxZcSun96As/images.jpg" alt="Kios Lima Detik di antara pohon palem dan area duduk terbuka" className="absolute inset-0 h-full w-full object-cover object-[center_40%]" data-id="element-175" data-mp="9igvb8esxojn" />
      <div className="absolute inset-0 bg-espresso/70" aria-hidden="true" data-id="element-176" data-mp="xaxghrtu5wn6" />

      <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-24 sm:px-8 lg:pb-24" data-id="element-177" data-mp="sa9qn9hcfluj">
        <div className="grid items-end gap-10 lg:grid-cols-[1fr_auto]" data-id="element-178" data-mp="nczr3108ptsz">
          <div className="max-w-3xl" data-id="element-179" data-mp="3d1ii934hv0k9">
            <h1 className="text-4xl font-semibold leading-[1.08] tracking-tight text-cream sm:text-5xl lg:text-[64px]" data-id="element-180" data-mp="3d2le7pgobt71">
              Pelarian 5 Detikmu:{" "}
              <span className="text-sage-light" data-id="element-181" data-mp="3j8ivmv0mo8sl">Kopi, Komunitas & Aktivitas Kota</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg" data-id="element-182" data-mp="3o7c243hhyzj9">
              Kopi Arabika yang nyaman dan sudut hijau yang teduh di Jakarta Selatan — tempat
              rehat sejenak di sela meeting, gowes, dan segala kesibukan kota.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-183" data-mp="3eb9150ydt6xw">
              <button type="button" onClick={onBook} className="group inline-flex items-center justify-center gap-2 rounded-full bg-sage px-7 py-3.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-150 ease-out hover:bg-sage-dark active:scale-[0.97]" data-id="element-184" data-mp="30ggfdkrweuiv">
                Pesan Aktivitas
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-185" data-mp="2hk85u4rurxhr" />
              </button>
              <a href="#menu" className="inline-flex items-center justify-center rounded-full border border-cream/40 px-7 py-3.5 text-sm font-semibold text-cream transition-colors duration-150 hover:border-cream hover:bg-cream/10" data-id="element-186" data-mp="2lml8gkbazfab">
                Lihat Menu
              </a>
            </div>
          </div>

          <dl className="grid grid-cols-3 gap-6 border-t border-cream/20 pt-6 text-cream lg:w-72 lg:grid-cols-1 lg:gap-5 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0" data-id="element-187" data-mp="degeefp1uar0">
            <div data-id="element-188" data-mp="161axp9a4r42w">
              <dt className="text-xs text-cream/60" data-id="element-189" data-mp="162uer23m1j5q">Outlet</dt>
              <dd className="mt-1 text-2xl font-semibold" data-id="element-190" data-mp="112pur23hu6ar">4</dd>
            </div>
            <div data-id="element-191" data-mp="114svoh66pju9">
              <dt className="text-xs text-cream/60" data-id="element-192" data-mp="x14nbw9qak7y">Aktivitas mingguan</dt>
              <dd className="mt-1 text-2xl font-semibold" data-id="element-193" data-mp="x37cke3249bm">6</dd>
            </div>
            <div data-id="element-194" data-mp="3lui8konbuvkb">
              <dt className="text-xs text-cream/60" data-id="element-195" data-mp="3lqugltxj6h7p">Buka setiap hari</dt>
              <dd className="mt-1 text-2xl font-semibold" data-id="element-196" data-mp="3hqk747aj58o3">07–21</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>;
}